// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-3NiXP";
var _3 = "white-1zRna";
export { _1 as "__esModule", _2 as "button", _3 as "white" }
export default { "__esModule": _1, "button": _2, "white": _3 }
